import PuzzleService from '_services/rest/modules/puzzle';
import Events from '_utils/events';
import { handleResourceLoadError } from '_utils';
import router from '@/router';
import { _LOAD_MODEL_ } from './components/PuzzleModel';

export default {
  state: {
    puzzle: null,
    puzzlePreviewData: null,
    puzzleCell: null,
    puzzleList: null,
    puzzleSearch: null,
    arrowPositions: null,
    questionSizes: null,
    arrowDirections: null,
    answerDirections: null,
    hasChanges: false,
  },
  mutations: {
    setArrowDirections(state, response) {
      state.arrowDirections = response;
    },
    setArrowPositions(state, response) {
      state.arrowPositions = response;
    },
    setAnswerDirections(state, response) {
      state.answerDirections = response;
    },
    setQuestionSizes(state, response) {
      state.questionSizes = response;
    },
    setPuzzleList(state, response) {
      state.puzzleList = response;
    },
    setPuzzle(state, puzzle) {
      state.puzzle = puzzle;
    },
    setPuzzlePreviewData(state, puzzlePreview) {
      state.puzzlePreviewData = puzzlePreview;
    },
    setPuzzleCell(state, cell) {
      state.puzzleCell = cell;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
    setPuzzleSearch(state, search) {
      state.puzzleSearch = search;
    },
  },
  actions: {
    getArrowDirections({ commit }) {
      PuzzleService.getArrowDirections().then(response => {
        commit('setArrowDirections', response);
      });
    },
    getArrowPositions({ commit }) {
      PuzzleService.getArrowPositions().then(response => {
        commit('setArrowPositions', response);
      });
    },
    getAnswerDirections({ commit }) {
      PuzzleService.getAnswerDirections().then(response => {
        commit('setAnswerDirections', response);
      });
    },
    getQuestionSizes({ commit }) {
      PuzzleService.getQuestionSizes().then(response => {
        commit('setQuestionSizes', response);
      });
    },
    getPuzzle({ commit, dispatch }, { id, search = null }) {
      return PuzzleService.getPuzzleById(id, search)
        .then(response => {
          Events.$emit(_LOAD_MODEL_, response);
          commit('setPuzzle', response);
        })
        .catch(error => {
          const isTemplate =
            router.currentRoute.name === 'admin-crossword-template-edit';
          handleResourceLoadError(
            dispatch,
            error,
            isTemplate
              ? 'admin-crossword-template-list'
              : 'admin-crossword-list',
          );
        });
    },
    getPuzzleList({ commit }, params) {
      if (params?.search) {
        commit('setPuzzleSearch', params.search);
      }

      PuzzleService.getPuzzles(params).then(response => {
        commit('setPuzzleList', response);
      });
    },
    setPuzzle({ commit }, model) {
      commit('setPuzzle', model);
    },
    setPuzzlePreviewData({ commit }, puzzlePreview) {
      commit('setPuzzlePreviewData', puzzlePreview);
    },
    setPuzzleCell({ commit }, cell) {
      commit('setPuzzleCell', cell);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    setPuzzleSearch({ commit }, search) {
      commit('setPuzzleSearch', search);
    },
  },
};
